import type { RootState } from '@/store';

/**
 * Certificado APENAS se ele for do alvo pedido.
 *
 * Sem a ancoragem, trocar de processo (ou de parte, no portal) devolvia o documento anterior no
 * render que antecede o `useEffect` do hook — e a view renderiza com `!isLoading && certificado`,
 * então o `loading` ainda `false` deixava passar um documento probatório de OUTRO alvo por um
 * frame. O `pending` do slice zera o certificado, mas só depois de o efeito rodar.
 *
 * Compara com `idSolicitado`, e não com `certificado.processoId`: o identificador da rota do
 * notificado é a `parteArbitral`, não o processo.
 */
export const selectCertificadoAcessosSentencaDoAlvo = (state: RootState, id: string) =>
  state.certificadoAcessosSentenca.idSolicitado === id
    ? state.certificadoAcessosSentenca.certificado
    : null;
export const selectCertificadoAcessosSentencaLoading = (state: RootState) =>
  state.certificadoAcessosSentenca.loading;
export const selectCertificadoAcessosSentencaError = (state: RootState) =>
  state.certificadoAcessosSentenca.error;
export const selectCertificadoAcessosSentencaSemPermissao = (state: RootState) =>
  state.certificadoAcessosSentenca.semPermissao;
export const selectCertificadoAcessosSentencaNaoPublicada = (state: RootState) =>
  state.certificadoAcessosSentenca.naoPublicada;
export const selectCertificadoAcessosSentencaPdfBaixando = (state: RootState) =>
  state.certificadoAcessosSentenca.pdfBaixando;
